<template>
	<article class="content-frame column fill">
		<section>
			<h2>Create</h2>
			<button>Create New Poll</button>
		</section>


		<h2>My Polls</h2>
		<section>
			<div v-for="poll in polls" v-bind:key="poll.id" class="poll-card">
				<div class="poll-info column flexible">
					<h3 class="poll-title">
						{{poll.state}} - {{poll.name}}
					</h3>
					<ul>
						<li>Method: {{poll.method}}</li>
						<li>URI: {{poll.uri}}</li>
						<li>Headers: {{poll.headers}}</li>
						<li>Cron: {{poll.cron}}</li>
					</ul>
				</div>
			</div>
		</section>
	</article>
</template>

<script>
	import { mapGetters } from 'vuex';

	export default {
		name: 'Polls',
		filters: {},
		data(){
			return {};
		},
		components: {
		},
		computed: {
			...mapGetters([
				'polls',
				'roles',
				'createPollStatus',
				'newPoll'
			])
		},
		methods: {
			createPoll: () => {

			},
			resetState() {
				// this.$store.dispatch('RESET_CREATE_POLL_STATE');
			},
			onSuccess(model) {
				// this.resetState();
			}
		},
		created() {
			this.$store.dispatch('POLLS_REQUEST', this.polls);
		}
	};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Polls.vue